export default "__VITE_ASSET__o0N$t8Yt__"